type SurveyPeriod = {
  customPeriod?: boolean;
  releaseAt?: string;
  closesAt?: string;
  [key: string]: unknown;
};

const normalizeDateTime = (value?: string): string | undefined => {
  if (!value) return undefined;
  const parsed = new Date(value);
  return Number.isNaN(parsed.getTime()) ? undefined : parsed.toISOString();
};

export const normalizeSurveyPeriodDates = <T extends SurveyPeriod>(survey?: T): T | undefined => {
  if (!survey) return survey;

  const releaseAt = normalizeDateTime(survey.releaseAt);
  const closesAt = normalizeDateTime(survey.closesAt);

  return {
    ...survey,
    ...(releaseAt ? { releaseAt } : survey.customPeriod ? {} : { releaseAt: undefined }),
    ...(closesAt ? { closesAt } : survey.customPeriod ? {} : { closesAt: undefined }),
  };
};

type ValidationError = {
  instancePath: string;
  message: string;
  schemaPath: string;
  keyword: string;
  params: Record<string, never>;
};

const validationError = (instancePath: string, message: string) => {
  const error: ValidationError = {
    instancePath,
    message,
    schemaPath: instancePath,
    keyword: instancePath.split("/").pop() || "survey",
    params: {},
  };
  throw { message, errors: [error] };
};

export const validateSurveyPeriod = <T extends SurveyPeriod>(survey?: T): T | undefined => {
  if (!survey?.customPeriod) return survey;

  if (!survey.releaseAt) {
    validationError(
      "/internalContentJSON/survey/releaseAt",
      "Informe a data e a hora de liberação da pesquisa."
    );
  }

  const releaseAt = Date.parse(survey.releaseAt as string);
  if (Number.isNaN(releaseAt)) {
    validationError(
      "/internalContentJSON/survey/releaseAt",
      "A data de liberação da pesquisa é inválida. Use o formato DD/MM/AAAA HH:mm."
    );
  }

  if (survey.closesAt) {
    const closesAt = Date.parse(survey.closesAt);
    if (Number.isNaN(closesAt)) {
      validationError(
        "/internalContentJSON/survey/closesAt",
        "A data de encerramento da pesquisa é inválida. Use o formato DD/MM/AAAA HH:mm."
      );
    }
    if (closesAt < releaseAt) {
      validationError(
        "/internalContentJSON/survey/closesAt",
        "O encerramento da pesquisa não pode ser anterior à liberação."
      );
    }
  }

  return survey;
};
